<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <router-link
      :to="{name: 'organisation-dashboard'}"
      class="navbar-brand">
      <img
        :src="org.logo || require('@/common/assets/img/logo-white.png')"
        class="img-logo mr-2"
        alt="logo"
      />
    </router-link>
    <button
      class="navbar-toggler collapsed"
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="showNav = !showNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <v-collapse-transition>
      <div class="navbar-collapse collapse show" v-if="showNav">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-dashboard'}"
                class="nav-link"
              >
                <i class="fa fa-nav fa-home"></i>
                {{ $t('word.organisation_dashboard') }}
              </router-link>
            </div>
          </li>
          <li class="nav-item">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-register-research-start'}"
                class="nav-link"
              >
                <i class="fa fa-nav fa-plus"></i>
                {{ $t('phrase.register_commercial') }}
              </router-link>
            </div>
          </li>

          <li class="nav-item">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-research-list'}"
                class="nav-link"
              >
                <i class="fa fa-chart-line fa-nav"></i>
                {{ $tc('word.research', 2) }}
              </router-link>
            </div>
          </li>

          <li class="nav-item" v-if="user.memberships.length > 1">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-list'}"
                class="nav-link"
                id="left-nav-organisation-list"
              >
                <i class="fa fa-building fa-nav"></i>
                {{ $t('phrase.my_organisations') }}
              </router-link>
            </div>
          </li>
          <li class="nav-item mb-4">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-organisation-detail'}"
                class="nav-link"
              >
                <i class="fa fa-building fa-nav"></i>
                {{ $t('phrase.my_organisation') }}
              </router-link>
            </div>
          </li>
          <li class="nav-item">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'organisation-user-profile'}"
                class="nav-link"
              >
                <i class="fa fa-user fa-nav"></i>
                {{ $t('phrase.my_account') }}
              </router-link>
            </div>
          </li>
          <li class="nav-item mb-4">
            <a :href="getBackendUrl('/auth/logout/')" class="nav-link text-danger">
              <i class="fa fa-power-off text-danger fa-nav"></i>
              {{ $t('word.logout') }}
            </a>
          </li>
          <li class="nav-item">
            <div @click="showNav = false">
              <a href="/dashboard/" target="_blank" class="nav-link text-primary">
                <i class="fa fa-table-columns fa-nav"></i>
                {{ $t('word.reviewers_dashboard') }}
                <i class="fa fa-arrow-up-right-from-square"></i>
              </a>
            </div>
          </li>
          <li class="nav-item">
            <div @click="showNav = false">
              <router-link
                :to="{name: 'admin-dashboard'}"
                class="nav-link"
              >
                <i class="fa fa-database fa-nav"></i>
                {{ $t('word.admin') }}
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </v-collapse-transition>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { getBackendUrl } from '@/common/utils/api';

export default {
  name: 'MobileNavbar',
  methods: { getBackendUrl },
  components: {
    'v-collapse-transition': CollapseTransition,
  },
  computed: {
    ...mapGetters(['org', 'user']),
  },
  data() {
    return {
      showNav: false,
    };
  },
};
</script>


<style scoped>
.img-logo {
  height: 50px;
  width: auto;
}

.fa-nav {
  width: 30px;
}
</style>
